import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import { CloseOutlined } from '@ant-design/icons';
import { Provider } from 'react-redux';
import { useMemoizedFn } from 'ahooks';
import { cn } from '@/utils/tw_common';
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogTitle } from '@/components/dialog';
import { Button } from '@/components/button';
import i18n from '@/locales/init';
import { useDeviceType } from '@/hooks/useDeviceType';
import store from '@/stores';
import { fetchUserPoints2, getStudentInfoAsync } from '@/stores/slice/user';
import { buyVipDialog } from '../Buy/components/BuyVip';
import { CustomerButton } from '../Customer/CustomerButton';

const img = 'https://duy-ielts-public.oss-cn-hangzhou.aliyuncs.com/front/points_lack.png';

export interface IPointsDialogProps {
  /**
   * 当前功能需要的金币
   */
  requiredPoints: number;
  /**
   * 用户当前拥有的金币
   */
  ownPoints: number;
  onClose?: () => void;
}

export const PointsDialog = React.memo<IPointsDialogProps>(({
  requiredPoints, ownPoints, onClose
}) => {
  const { is_mobile } = useDeviceType();
  const [open, setOpen] = useState<boolean>(true);

  const handleClose = useMemoizedFn(() => {
    setOpen(false);
    onClose && onClose();
  });

  const buyVip = useMemoizedFn(() => {
    buyVipDialog(handleClose);
    handleClose();
  });

  const gotoTasks = useMemoizedFn(() => {
    handleClose();
  });

  return <Dialog open={open} onOpenChange={handleClose}>
    <DialogContent className={cn('rounded-[16px] !p-0 mt-[-40px]', is_mobile ? 'w-[calc(100vw_-_32px)]' : 'w-[352px]')}>
      <DialogTitle className="text-[#4B4B4B] text-[20px] font-semibold leading-[68px] border-b-[1px] border-[#E5E5E5] pl-[26px]">{i18n.t('金币不足')}</DialogTitle>
      <DialogClose className="absolute right-6 top-6">
        <CloseOutlined className="text-black/60 text-[16px]" />
      </DialogClose>
      <DialogDescription className="pb-6 px-6">
        {
          !is_mobile ? <div style={{ backgroundImage: `url(${img})` }} className="mt-[10px] w-full h-[108px] leading-[108px] block bg-contain bg-no-repeat bg-center"><br /></div>
            : null
        }
        <div className="mt-[20px]">
          <p className="text-[#4B4B4B] text-[16px] font-medium text-center">
            <span>{i18n.t('本次练习需要')}</span>
            <span className="text-[#1CB0F6] mx-1">{i18n.t('{{points}}', { points: requiredPoints })}</span>
            <span>{i18n.t('金币，您的余额为')}</span>
            <span className="mx-1">{i18n.t('{{points}}', { points: ownPoints })}</span>
          </p>
        </div>
        <div className="flex flex-col mt-8" >
          {/* <Button value='confirm' className='rounded-[16px] h-[44px] bg-[#3F22EC] border-[#3C4DFF] hover:bg-[#3F22EC] text-white text-[1.167rem]' onClick={buyVip}>{i18n.t('开通题库会员，得无限金币')}</Button> */}
          {/* <Button variant='bordered_default' className="rounded-[16px] h-[44px] text-[1.167rem] mt-[16px]" onClick={gotoTasks}>{i18n.t('做任务，得金币')}</Button> */}
          <CustomerButton className=' w-full rounded-[16px] h-[44px] bg-[#3F22EC] border-[#3C4DFF] hover:bg-[#3F22EC] text-white text-[1.167rem]' />
        </div>
      </DialogDescription>
    </DialogContent>
  </Dialog>;
});

let open = false;
export const openPointsDialog = (props: IPointsDialogProps) => {
  // render
  if (open) {
    return;
  }
  open = true;
  const container = document.createElement('div');
  container.id = 'points';
  container.style.position = 'fixed';
  document.body.appendChild(container);

  const root = createRoot(container);

  const handleClose = () => {
    open = false;
    Promise.all([
      store.dispatch(getStudentInfoAsync()).unwrap(),
      store.dispatch(fetchUserPoints2()).unwrap(),
    ]).then(() => {
      props.onClose && props.onClose();
    }).catch(() => {
      props.onClose && props.onClose();
    });
    root.unmount();
    if (container.parentElement) {
      container.parentElement.removeChild(container);
    }
  };

  root.render(
    <Provider store={store}>
      <PointsDialog
        {...props}
        onClose={handleClose}
      />
    </Provider>
  );
};
